import {
	Button,
	ButtonVariants,
	Chip,
	Text,
	TextVariants,
} from "@centricsoftware/design-system";
import clsx from "clsx";
import { CANCEL_RES, SAVE_RES } from "csi/components/constants";
import {
	FlexRowCenter
} from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import css from "./FormDefinitionModeHeader.module.css";
import { useFormDefinitionStore } from "./FormDefinitionStore";

export const FormDefinitionModeHeader: FunctionComponent = observer(() => {
	const {
		formType,
		isEditFormDefinitionMode,
		onCancelFormDefinition,
		onSaveFormDefinition,
		setIsEditFormDefinitionMode,
	} = useFormDefinitionStore();
	const setFormDefinitionModeTrue = () => setIsEditFormDefinitionMode(true);

	return (
		<FlexRowCenter
			className={clsx(
				css.formDefinitionModeHeaderZindex,
				css.formDefinitionModeHeaderBackground,
				isEditFormDefinitionMode && css.formDefinitionModeHeaderBackgroundWhite,
			)}
			justifyContent="space-between"
			p={3}
			position="relative"
		>
			{isEditFormDefinitionMode ? (
				<FlexRowCenter gap={4}>
					<Chip title={formType} />
					<Text
						childrenRes={{ res: "FormBuilderFormDefinitionEdit" }}
						variant={TextVariants.HeadingPrimary}
					/>
				</FlexRowCenter>
			) : (
				<Text
					childrenRes={{
						res: "FormBuilderFormDefinitionTitle",
						params: [formType],
					}}
					variant={TextVariants.HeadingPrimary}
				/>
			)}
			{isEditFormDefinitionMode ? (
				<FlexRowCenter>
					<Button
						childrenRes={SAVE_RES}
						dataCsiAutomation="FormDefinitionModeHeader-SaveButton"
						onClick={onSaveFormDefinition}
						variant={ButtonVariants.primary}
					/>
					<Button
						childrenRes={CANCEL_RES}
						dataCsiAutomation="FormDefinitionModeHeader-CancelButton"
						onClick={onCancelFormDefinition}
						variant={ButtonVariants.link}
					/>
				</FlexRowCenter>
			) : (
				<Button
					childrenRes={{ res: "FormBuilderFormDefinitionEdit" }}
					dataCsiAutomation="FormDefinitionModeHeader-EditButton"
					onClick={setFormDefinitionModeTrue}
					variant={ButtonVariants.primary}
				/>
			)}
		</FlexRowCenter>
	);
});